"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PasswordInput = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactstrap = require("reactstrap");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _UserValidator = require("../../validators/UserValidator/UserValidator");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var StyledTooltip = (0, _styledComponents["default"])(_reactstrap.Tooltip)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  .tooltip-inner {\n    text-align: left;\n    font-size: 12px;\n    max-width: 245px;\n\n    .icon-spacer {\n      width: 16px;\n      display: inline-block;\n      text-align: center;\n    }\n  }\n\n"])));

/**
 * Password Input Component
 */
var PasswordInput = exports.PasswordInput = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(PasswordInput, _Component);
  var _super = _createSuper(PasswordInput);
  function PasswordInput(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, PasswordInput);
    _this = _super.call(this, props);
    _this.state = {
      showTip: false,
      touched: false,
      tooltipValidation: _UserValidator.UserValidator.getPasswordTooltipValidation(props.value || "")
    };
    _this._handleChange = _this._handleChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this._invalid = _this._invalid.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  (0, _createClass2["default"])(PasswordInput, [{
    key: "_handleChange",
    value: function _handleChange(e) {
      var value = e.target.value;
      this.setState({
        touched: true,
        tooltipValidation: _UserValidator.UserValidator.getPasswordTooltipValidation(value)
      });
      this.props.onChange(e);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        className = _this$props.className,
        value = _this$props.value,
        defaultValue = _this$props.defaultValue,
        label = _this$props.label,
        placeholder = _this$props.placeholder,
        autoComplete = _this$props.autoComplete;
      return /*#__PURE__*/_react["default"].createElement("div", null, this._getTooltipNode(), /*#__PURE__*/_react["default"].createElement(_reactstrap.Input, {
        onChange: this._handleChange,
        className: className,
        value: value,
        defaultValue: defaultValue,
        label: label,
        autoComplete: autoComplete,
        type: "password",
        id: "passwordInput",
        placeholder: placeholder || "Your password",
        onFocus: function onFocus() {
          _this2.setState({
            showTip: true
          });
        },
        onBlur: function onBlur() {
          _this2.setState({
            showTip: false
          });
        },
        isInvalid: this.state.touched && this._invalid()
      }));
    }
  }, {
    key: "_invalid",
    value: function _invalid() {
      return this.state.tooltipValidation.filter(function (v) {
        return !v.valid;
      }).length > 0;
    }
  }, {
    key: "_getTooltipNode",
    value: function _getTooltipNode() {
      if (!this.state.showTip) return;
      var validation = this.state.tooltipValidation;
      var validationNodes = validation.map(function (_ref) {
        var valid = _ref.valid,
          message = _ref.message;
        var iconName = valid ? _freeSolidSvgIcons.faCheck : _freeSolidSvgIcons.faTimes;
        var iconColor = valid ? 'green' : 'red';
        return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
          className: "icon-spacer"
        }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
          icon: iconName,
          style: {
            color: iconColor
          }
        }), "  "), message);
      });
      return /*#__PURE__*/_react["default"].createElement(StyledTooltip, {
        placement: "top",
        isOpen: this.state.showTip,
        target: "passwordInput",
        className: "in password-tooltip",
        id: "password-tooltip"
      }, "Passwords must contain:", validationNodes);
    }
  }]);
  return PasswordInput;
}(_react.Component);
PasswordInput.propTypes = {
  className: _propTypes["default"].string,
  defaultValue: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  value: _propTypes["default"].string,
  label: _propTypes["default"].string
};